export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-seedling-line',
      title: 'Fresh Crop Sojat Henna',
      description: 'Sourced directly from the latest harvest season'
    },
    {
      icon: 'ri-filter-3-line',
      title: 'Fine Mesh Quality',
      description: 'Ultra-smooth texture for perfect application'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Direct Factory Price',
      description: 'No middlemen, best wholesale rates'
    },
    {
      icon: 'ri-palette-line',
      title: 'No Artificial Color',
      description: '100% natural green color from pure henna'
    },
    {
      icon: 'ri-truck-line',
      title: 'Reliable Bulk Supply',
      description: 'Consistent availability for large orders'
    },
    {
      icon: 'ri-star-line',
      title: 'Consistent Quality',
      description: 'Every batch meets our high standards'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Us
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            What makes Pavitra Rishta your trusted henna powder partner
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-green-50 to-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h3>
              <p className="text-sm text-gray-600">{reason.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-12 shadow-2xl">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Ready to Order Premium Henna Powder?
            </h3>
            <p className="text-base md:text-lg text-white/90 mb-8 max-w-2xl mx-auto">
              Get the best quality Sojat henna powder at factory-direct prices. Contact us today for bulk orders and wholesale inquiries.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    const offset = 80;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                  }
                }}
                className="px-8 py-4 bg-white text-green-600 rounded-full hover:bg-gray-100 transition-all transform hover:scale-105 text-base font-semibold whitespace-nowrap cursor-pointer shadow-lg"
              >
                Get Quote Now
              </button>
              <a
                href="https://wa.me/919649408405"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-all transform hover:scale-105 text-base font-semibold whitespace-nowrap cursor-pointer shadow-lg flex items-center justify-center space-x-2"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span>WhatsApp Us</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}